import { useState } from "react";
import { Sidebar } from "./Sidebar";
import { cn } from "@/shared/lib/utils";

interface AppLayoutProps {
    children: React.ReactNode;
}

/**
 * AppLayout - Main application layout with sidebar navigation
 * 
 * This component replaces the traditional header-based navigation
 * with a modern sidebar pattern used by apps like Notion, Linear, Slack.
 */
export function AppLayout({ children }: AppLayoutProps) {
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

    return (
        <div className="flex h-screen bg-background overflow-hidden">
            {/* Sidebar */}
            <Sidebar
                collapsed={sidebarCollapsed}
                onCollapsedChange={setSidebarCollapsed}
            />

            {/* Main Content */}
            <main className="flex-1 overflow-auto">
                {children}
            </main>
        </div>
    );
}
